import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { editCandidateTechnologies, getCandidate, getCandidateProfileStatus } from '../../actions/candidatesActions'
import Swal from 'sweetalert2'
import technologies from "../../components/technologies.json"
import SubMenuHabilities from '../../components/menus/SubMenuHabilities'
import softwares from '../../components/softwares'
import ecosystem from '../../components/ecosystem'
import Select from 'react-select'
import { useParams } from 'react-router-dom'

export default function Technologies() {
    const {id: candidateId} = useParams() || {}
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()

    const {candidate, resultcandidate} = useSelector(state=>state.candidates)

    useEffect(() => {
        if(client){
            dispatch(getCandidate(candidateId || client?.id))
        }
    },[dispatch, t, client])

    const [technologiesForm, setTechnologiesForm] = useState({
        technologyGroups: [],
		officeLevel: 'low',
		ecosystems: [],
        softwares: [],
        noTechnologyGroups: false,
        noEcosystems: false,
        noSoftwares: false
    })

    const handleEditTechnologies = async(e) => {
        e.preventDefault()

        dispatch(editCandidateTechnologies(
            candidateId || client?.id,
            {
                ...technologiesForm,
                technologyGroups: !technologiesForm.noTechnologyGroups ? await Promise.all(technologiesForm.technologyGroups.map(async technologyGroup => {
                        return {id: technologyGroup.id, technologies: await technologyGroup.technologies ? technologyGroup.technologies.map(technology => {
                            return technology.value + (technology.otherValues || '')
                        }) : undefined}
                    })).then(res => {return res}) : null,
                ecosystems: !technologiesForm.noEcosystems ? await Promise.all(technologiesForm.ecosystems.map(async ecosystem => {
                        return ecosystem.value + (ecosystem.otherValues || '')
                    })).then(res => {return res}) : null,
                softwares: !technologiesForm.noSoftwares ? await Promise.all(technologiesForm.softwares.map(async software => {
                        return software.value + (software.otherValues || '')
                    })).then(res => {return res}) : null
            }
        ))

        setTechnologiesForm({
            technologyGroups: [],
            officeLevel: null,
            ecosystems: [],
            softwares: [],
            noTechnologyGroups: false,
            noEcosystems: false,
            noSoftwares: false
        })
    }

    const handleTechnologyGroupCheckbox = (selected, id) => {
            if (selected) {
                if (technologiesForm.technologyGroups.length < 4) {
                    setTechnologiesForm({
                        ...technologiesForm,
                        technologyGroups: [...technologiesForm.technologyGroups, {id: id, technologies: []}],
                        noTechnologyGroups: false
                    })
                } else {
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.maxTechnologyGroupMessage')
                    })
                }
            } else {
                setTechnologiesForm({
                    ...technologiesForm,
                    technologyGroups: technologiesForm.technologyGroups.filter(t => t.id !== id)
                })
            }
    }

    const handleSelectTechnology = (values, technologyGroupId) => {
        if(technologiesForm.technologyGroups.find(tg => tg.id === technologyGroupId)?.technologies && (technologiesForm.technologyGroups.find(tg => tg.id === technologyGroupId).technologies.length < 2 || values.length < 2)) {
            setTechnologiesForm({
                ...technologiesForm,
                technologyGroups: technologiesForm.technologyGroups.map(technologyGroup => {
                    if (technologyGroup.id === technologyGroupId) {
                        return {...technologyGroup, technologies: values}
                    } else {
                        return technologyGroup
                    }
                })
            })
        } else {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('profile.candidate.maxTechnologiesMessage')
            })
        }
    }

    const handleOtherTechnologyInput = (technologyGroupId, value) => {
        setTechnologiesForm({
            ...technologiesForm,
            technologyGroups: technologiesForm.technologyGroups.map(technologyGroup => {
                if (technologyGroup.id === technologyGroupId) {
                    return {...technologyGroup, technologies: technologyGroup.technologies.map(t => {
                        if (t.value === 'others: ') {
                            return {...t, otherValues: value}
                        } else {
                            return t
                        }
                    })}
                } else {
                    return technologyGroup
                }
            })
        })
    }
    
    const handleEcosystemsInput = (e) => {
        setTechnologiesForm({
            ...technologiesForm,
            ecosystems: technologiesForm.ecosystems.map(ecosystem => {
                if (ecosystem.value.includes('others: ')) {
                    return {...ecosystem, otherValues: e.target.value}
                } else {
                    return ecosystem
                }
            })
        })
    }

    const handleSoftwaresEducationChange = (values) => {

        if(values.length < 6){
            setTechnologiesForm({...technologiesForm, softwares: values, noSoftwares: false})
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('profile.candidate.maxSoftwaresEducation')
            })
        }
    }

    const handleEducationalSoftwareInput = (e) => {
        setTechnologiesForm({
            ...technologiesForm,
            softwares: technologiesForm.softwares.map(software => {
                if (software.value.includes('others: ')) {
                    return {...software, otherValues: e.target.value}
                } else {
                    return software
                }
            })
        })
    }

    const handleNoTechnologiesCheckbox = ({target}) => {
        const checked = target.checked
        if (checked && technologiesForm.technologyGroups.length > 0) {
            Swal.fire({
                icon: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                text: t('profile.candidate.noTechnologiesCheckWarningText'),
                cancelButtonText: t('global.cancel'),
                confirmButtonText: t('global.yes')
            }).then(result => {
                if (result.isConfirmed) {
                    setTechnologiesForm({...technologiesForm, noTechnologyGroups: checked, technologyGroups: []})
                }
            })
        } else {
            setTechnologiesForm({...technologiesForm, noTechnologyGroups: checked})
        }
    }

    const handleNoEcosystemsCheckbox = ({target}) => {
        const checked = target.checked
        if (checked && technologiesForm.ecosystems.length > 0) {
            Swal.fire({
                icon: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                text: t('profile.candidate.noEcosystemsCheckWarningText'),
                cancelButtonText: t('global.cancel'),
                confirmButtonText: t('global.yes')
            }).then(result => {
                if (result.isConfirmed) {
                    setTechnologiesForm({...technologiesForm, noEcosystems: checked, ecosystems: []})
                }
            })
        } else {
            setTechnologiesForm({...technologiesForm, noEcosystems: checked})
        }
    }

    const handleNoSoftwaresCheckbox = ({target}) => {
        const checked = target.checked
        if (checked && technologiesForm.softwares.length > 0) {
            Swal.fire({
                icon: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                text: t('profile.candidate.noSoftwaresCheckWarningText'),
                cancelButtonText: t('global.cancel'),
                confirmButtonText: t('global.yes')
            }).then(result => {
                if (result.isConfirmed) {
                    setTechnologiesForm({...technologiesForm, noSoftwares: checked, softwares: []})
                }
            })
        } else {
            setTechnologiesForm({...technologiesForm, noSoftwares: checked})
        }
    }

    useEffect(() => {
        if(resultcandidate){
            switch (resultcandidate) {
                case 'successEditTechnologies':
                    dispatch(getCandidate(candidateId || client?.id))
                    dispatch(getCandidateProfileStatus(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successEditTechnologies')
                    })
                    break;
                case 'errorEditTechnologies':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.errorEditTechnologies')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultcandidate])

    useEffect(() => {
        if (candidate) {
            setTechnologiesForm({
                noTechnologyGroups: candidate.technologies.noTechnologyGroups === undefined || candidate.technologies.noTechnologyGroups === null ? false : candidate.technologies.noTechnologyGroups,
                technologyGroups: candidate.technologies?.technologyGroups?.map(technologyGroup => {
                    return {id: technologyGroup.id, technologies: technologyGroup.technologies.map(technology => {
                        if (technology.includes('others: ')) {
                            return { label: t('profile.candidate.otherTechnology'), value: 'others: ', otherValues: technology.split('others: ')[1] }
                        } else {
                            return { label: technology, value: technology }
                        }
                    })}
                }) || [],
                officeLevel: candidate.technologies?.officeLevel || 'low',
                noEcosystems: candidate.technologies.noEcosystems === undefined || candidate.technologies.noEcosystems === null ? false : candidate.technologies.noEcosystems,
                ecosystems: candidate.technologies?.ecosystems?.map(ecosystem => {
                    if (ecosystem.includes('others: ')) {
                        return { label: t('profile.candidate.otherTechnology'), value: 'others: ', otherValues: ecosystem.split('others: ')[1] }
                    } else {
                        return { label: ecosystem, value: ecosystem }
                    }
                }) || [],
                noSoftwares: candidate.technologies.noSoftwares === undefined || candidate.technologies.noSoftwares === null ? false : candidate.technologies.noSoftwares,
                softwares: candidate.technologies?.softwares?.map(software => {
                    if (software.includes('others: ')) {
                        return { label: t('profile.candidate.otherTechnology'), value: 'others: ', otherValues: software.split('others: ')[1] }
                    } else {
                        return { label: software, value: software }
                    }
                }) || []
            })
        }
    }, [candidate, t])

    return (
        <Container className='cuerpo'>
            <Row className='mb-4'>
                <Col className='d-flex align-items-center'>
                    <img src="/images/habilidadesbig.svg" alt="Icono Habilidades" />
                    <h1 className='ms-2 m-0'>{t('menus.skills')}</h1>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                    <Card className='mb-5 sombra lateral' >
                        <Card.Body className='p-0 d-flex'>
                            <div className='d-none d-sm-block submenu-lateral'>
                                    <SubMenuHabilities seccion='technologies' usertype={candidateId ? 'Superadmin' : 'Candidate'} candidateId={candidateId}/>
                            </div>
                            <div className='px-5 py-3 contenido-datos'>
                                <Row className="mt-5 mb-3">
                                    <Col>
                                        <h3>{t('profile.candidate.usedTechnologies')}</h3>
                                        {t('profile.candidate.usedTechnologiesSubtitle')}
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col>
                                        <Form onSubmit={handleEditTechnologies} className='mt-1 mb-3'>
                                            {
                                                technologies.map((technology) => (
                                                    <Row key={technology.id} className='borde-inferior py-4'>
                                                        <Row>
                                                            <Col className='d-flex align-items-center justify-content-between'>
                                                                <h4>{technology.id} - {technology.name}</h4>
                                                                <div>
                                                                    <Form.Check
                                                                        className="mx-2"
                                                                        type="switch"
                                                                        name={technology.name}
                                                                        id={technology.name}
                                                                        onChange={e => handleTechnologyGroupCheckbox(e.target.checked, technology.id)} 
                                                                        checked={technologiesForm?.technologyGroups?.find(t => t.id === technology.id) ? true : false}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        {
                                                            technologiesForm.technologyGroups.find(tg => tg.id === technology.id) && technology.technologies &&
                                                                <Row className='align-items-end'>
                                                                    <Col xs={12} lg={6}>
                                                                        <Select
                                                                            isMulti
                                                                            options={[
                                                                                ...technology.technologies.map(technology => {
                                                                                    return { label: technology, value: technology }
                                                                                }), { label: t('profile.candidate.otherTechnology'), value: 'others: ', otherValues: '' }
                                                                            ]}
                                                                            value={technologiesForm.technologyGroups.find(tg => tg.id === technology.id)?.technologies}
                                                                            onChange={(values) => handleSelectTechnology(values, technology.id)}
                                                                        />
                                                                    </Col>
                                                                    {
                                                                        technologiesForm.technologyGroups.find(tg => tg.id === technology.id)?.technologies?.find(t => t.hasOwnProperty('otherValues')) &&
                                                                        <Col xs={12} lg={6}>
                                                                            <Form.Control
                                                                                type='text'
                                                                                name={`${technology.name}other`}
                                                                                onChange={e => {handleOtherTechnologyInput(technology.id, e.target.value)}}
                                                                                value={technologiesForm?.technologyGroups?.find(t => t.id === technology.id)?.technologies?.find(t => t.value.includes('others: '))?.otherValues || ''}
                                                                                placeholder={t('profile.candidate.otherTechnology')}
                                                                            />
                                                                        </Col>
                                                                    }
                                                                </Row>
                                                        }
                                                        
                                                    </Row>
                                                ))
                                            }
                                            <Row className='my-3'>
                                                <Col>
                                                    <Form.Label htmlFor='noTechnologyGroupsSwitch' className='m-0 me-5'>{t('profile.candidate.noTechnologyGroups')}</Form.Label>
                                                    <div className='d-flex'>
                                                        <Form.Check
                                                            className="mx-2"
                                                            type="switch"
                                                            name="switch"
                                                            id="noTechnologyGroupsSwitch"
                                                            onChange={handleNoTechnologiesCheckbox} 
                                                            checked={technologiesForm.noTechnologyGroups || false}
                                                        />
                                                        {technologiesForm.noTechnologyGroups ? t('global.yes') : t('global.no')}
                                                    </div>
                                                </Col>
                                            </Row>
                                            
                                            <Row className="mt-4">
                                                <Col>
                                                    <h3>{t('profile.candidate.officeLevel.title')}</h3>
                                                </Col>
                                            </Row>
                                            <Row className='my-3 pb-4 borde-inferior'>
                                                <Col xs={12} lg={6}>
                                                    <Form.Select onChange={(e) => setTechnologiesForm({...technologiesForm, officeLevel: e.target.value})} value={technologiesForm.officeLevel || ''}>
                                                        {
                                                            ['low', 'medium', 'high', 'advanced'].map(type => (
                                                                <option value={type} key={type}>{t('profile.candidate.officeLevel.' + type)}</option>
                                                            ))
                                                        }
                                                    </Form.Select>
                                                </Col>
                                            </Row>
                                            <Row className="mt-4">
                                                <Col>
                                                    <h3>{t('profile.candidate.ecosystems.title')}</h3>
                                                </Col>
                                            </Row>
                                            <Row className='align-items-end'>
                                                <Col xs={12} lg={6}>
                                                    <Select
                                                        isMulti
                                                        options={[
                                                            ...ecosystem.map(ecosystem => {return { label: ecosystem, value: ecosystem }}),
                                                            { label: t('profile.candidate.otherTechnology'), value: 'others: ', otherValues: '' }
                                                        ]}
                                                        value={technologiesForm.ecosystems}
                                                        onChange={values => setTechnologiesForm({...technologiesForm, ecosystems: values, noEcosystems: false})}
                                                    />
                                                </Col>
                                                {
                                                    technologiesForm.ecosystems?.find(e => e.hasOwnProperty('otherValues')) &&
                                                        <Col xs={12} lg={6}>
                                                            <Form.Control
                                                                type='text'
                                                                onChange={handleEcosystemsInput}
                                                                value={technologiesForm?.ecosystems.find(e => e.value.includes('others: '))?.otherValues || ''}
                                                                placeholder={t('profile.candidate.ecosystems.others')}
                                                            />
                                                        </Col> 
                                                }
                                            </Row>
                                            <Row className='my-3'>
                                                <Col>
                                                    <Form.Label htmlFor='noEcosystemsSwitch' className='m-0 me-5'>{t('profile.candidate.noEcosystems')}</Form.Label>
                                                    <div className='d-flex'>
                                                        <Form.Check
                                                            className="mx-2"
                                                            type="switch"
                                                            name="switch"
                                                            id="noEcosystemsSwitch"
                                                            onChange={handleNoEcosystemsCheckbox} 
                                                            checked={technologiesForm.noEcosystems || false}
                                                        />
                                                        {technologiesForm.noEcosystems ? t('global.yes') : t('global.no')}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className="mt-4">
                                                <Col>
                                                    <h3>{t('profile.candidate.educationalSoftwareTitle')}</h3>
                                                </Col>
                                            </Row>
                                            <Row className='my-3 align-items-end'>
                                                <Col xs={12} lg={6}>
                                                    <Select
                                                        isMulti
                                                        options={[
                                                            ...softwares.map(software => {return { label: software, value: software }}),
                                                            { label: t('profile.candidate.otherTechnology'), value: 'others: ', otherValues: '' }
                                                        ]}
                                                        value={technologiesForm.softwares}
                                                        onChange={handleSoftwaresEducationChange}
                                                    />
                                                </Col>
                                                {
                                                    technologiesForm.softwares?.find(e => e.hasOwnProperty('otherValues')) &&
                                                        <Col xs={12} lg={6}>
                                                            <Form.Control
                                                                type='text'
                                                                onChange={handleEducationalSoftwareInput}
                                                                value={technologiesForm?.softwares.find(e => e.value.includes('others: '))?.otherValues || ''}
                                                                placeholder={t('profile.candidate.softwares.others')}
                                                            />
                                                        </Col>
                                                }
                                            </Row>
                                            <Row className='my-3'>
                                                <Col>
                                                    <Form.Label htmlFor='noSoftwaresSwitch' className='m-0 me-5'>{t('profile.candidate.noSoftwares')}</Form.Label>
                                                    <div className='d-flex'>
                                                        <Form.Check
                                                            className="mx-2"
                                                            type="switch"
                                                            name="switch"
                                                            id="noSoftwaresSwitch"
                                                            onChange={handleNoSoftwaresCheckbox}
                                                            checked={technologiesForm.noSoftwares || false}
                                                        />
                                                        {technologiesForm.noSoftwares ? t('global.yes') : t('global.no')}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className="my-3 d-flex justify-content-end">
                                                <Col xs='12' lg='5'>
                                                    <Button type="submit" className="btn-primary w-100 my-2">{t('profile.candidate.saveTechnologies')}</Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}